import { Plane, Dice5, Building2, ArrowUpRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { CONTACT } from "../i18n";
import { FadeUp } from "./Reveal";

const SERVICE_IMAGES = [
  "https://images.unsplash.com/photo-1764605206511-7a649d9df63b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBibGFjayUyMHNlZGFuJTIwbmlnaHQlMjBkcml2aW5nfGVufDB8fHx8MTc4NDgzNDUwOXww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/34025114/pexels-photo-34025114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/14909610/pexels-photo-14909610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

const ICONS = [Plane, Dice5, Building2];

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-24 md:py-40 bg-[#0a0a0a]" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp>
          <p className="font-mono text-xs tracking-[0.3em] text-[#d4af37] mb-6">{t.services.overline}</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-2xl leading-tight">
            {t.services.title}
          </h2>
        </FadeUp>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            // Tetris layout: first card large (span 4 + tall), second tall span 2, third wide span 6
            const layout =
              i === 0
                ? "md:col-span-4 md:row-span-2 aspect-[4/3] md:aspect-auto md:min-h-[560px]"
                : i === 1
                ? "md:col-span-2 md:min-h-[560px] aspect-[4/3] md:aspect-auto"
                : "md:col-span-6 aspect-[16/9] md:aspect-[21/8]";
            return (
              <a
                key={i}
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className={`hover-lift img-zoom-parent group relative overflow-hidden border border-white/10 hover:border-[#d4af37]/40 ${layout}`}
                data-testid={`service-card-${i}`}
              >
                <img
                  src={SERVICE_IMAGES[i]}
                  alt={item.title}
                  className="img-zoom absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20" />
                <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-10">
                  <div className="flex items-center justify-between">
                    <Icon size={28} className="text-[#d4af37]" strokeWidth={1.4} />
                    <ArrowUpRight
                      size={26}
                      className="text-white/60 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300"
                    />
                  </div>
                  <div>
                    <span className="font-mono text-[11px] tracking-[0.3em] text-[#d4af37]">{item.tag}</span>
                    <h3 className="font-serif text-3xl md:text-4xl text-white mt-3 mb-3">{item.title}</h3>
                    <p className="font-sans text-sm md:text-base text-white/65 max-w-md leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
